/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>反馈列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-button size="small" type="primary" @click="switchlist">切换</el-button> -->

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%; margin-top: 40px;">
      <el-table-column prop="email" label="用户邮箱" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号" width="180">
      </el-table-column>
      <el-table-column prop="ssid" label="SSID" width="100">
      </el-table-column>
      <el-table-column prop="title" label="书名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="content" label="反馈内容" min-width="300">
      </el-table-column>
      <el-table-column prop="replyContent" label="回复内容" min-width="300">
      </el-table-column>
      <el-table-column prop="createTime" label="反馈时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag type="success" size="small" v-if="scope.row.status == '已处理'">{{ scope.row.status }}</el-tag>
          <el-tag type="danger" size="small" v-else>{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="scope.row.status != '已处理'"
            @click="handleEdit(scope.row.id)">确定</el-button>
          <el-button size="mini" type="success" v-if="scope.row.status != '已处理'"
            @click="emailOpen(scope.row.id,scope.row.email, scope.row.title)">回复</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 回复界面 -->
    <el-dialog title="提示" :visible.sync="emaildialog" width="60%" :before-close="emailClose">
      <el-form :model="emaildata" label-width="80px">
        <el-form-item label="收件人">
          <el-input v-model="emaildata.tos[0]" disabled></el-input>
        </el-form-item>
        <el-form-item label="主题">
          <el-input v-model="emaildata.subject" disabled></el-input>
        </el-form-item>
        <el-form-item label="快捷回复">
          <el-select v-model="fast" placeholder="请选择快捷语句" @change="fastchange">
            <el-option :label="item.value" :value="item.value" v-for="(item, index) in fastlist"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="emaildata.content" type="textarea" :autosize="{ minRows: 6 }"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="emailClose">取 消</el-button>
          <el-button type="primary" @click="emailSend">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { FeedbackList, FeedbackUpdate, FeedbackReply } from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      emaildialog: false,//回复弹窗
      switch: true,//反馈切换
      formInline: {
        ssid: "",
        content: "",
        orderNo: "",
        status: "",
        pageNo: 1,
        pageSize: 15
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      emaildata: {
        tos: [
        ],
        subject: "",
        content: "",
        businessId:''
      },
      fast: '',
      fastlist: [{
        value: "",
      }, {
        value: "复制以下链接在浏览器打开下载。",
      },
      {
        value: '感谢购买，有问题继续反馈，我们及时回复。',
      },
      ]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  methods: {
    // 获取用户列表
    getdata(parameter) {
      this.loading = true
      FeedbackList(parameter).then(res => {
        this.loading = false

        this.userparm = res.data
        this.listData = res.data.lists
        this.pageparm.currentPage = res.data.pageNo
        this.pageparm.pageSize = res.data.pageSize
        this.pageparm.total = res.data.count
      }
      )
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 确定
    handleEdit(id) {
      FeedbackUpdate(id).then(res => {
        this.$message.success(res.message)
        this.getdata(this.formInline)
      })
    },
    fastchange() {
      this.emaildata.content = this.fast + this.emaildata.content
    },
    emailClose() {
      this.emaildialog = false
    },
    emailOpen(id,email ,name) {
      this.emaildialog = true
      this.emaildata.tos = [email]
      this.emaildata.subject = name + '的反馈回复'
      this.emaildata.businessId=id
    },
    emailSend() {
      FeedbackReply(this.emaildata).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
        this.emaildialog = false
        this.fast = ''
        this.emaildata.content = ''
      })
    },
    switchlist() {
      this.switch = !this.switch;
      const status = this.switch ? '已处理' : '未处理';
      this.formInline.status = status;
      this.getdata(this.formInline);
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/feedback/Feedback.vue